import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import TypeScript translation files (they'll be bundled as modules)
import { translations as enTS } from './translations/en';
import { translations as nlTS } from './translations/nl';
import { translations as frTS } from './translations/fr';

const resources = {
  en: {
    translation: enTS
  },
  nl: {
    translation: nlTS
  },
  fr: {
    translation: frTS
  }
};

i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Language detection options
    detection: {
      // Order of language detection methods
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      
      // Keys to look for in localStorage
      lookupLocalStorage: 'foodweb_language',
      
      // Query string parameter name
      lookupQuerystring: 'lng',
      
      // Cache user language
      caches: ['localStorage'],
      
      // Exclude certain paths from detection
      excludeCacheFor: ['cimode'],
      
      // Convert language codes to our supported languages
      convertDetectedLanguage: (lng: string) => {
        // Handle language variants
        if (lng.startsWith('en')) return 'en';
        if (lng.startsWith('nl')) return 'nl';
        if (lng.startsWith('fr')) return 'fr';
        return 'en'; // Default fallback
      }
    },

    // Supported languages
    supportedLngs: ['en', 'nl', 'fr'],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],

    // React specific options
    react: {
      useSuspense: false, // Disable suspense for now to avoid loading issues
    },

    // Keyseparator and nsseparator
    keySeparator: '.',
    nsSeparator: ':',

    // Load path for missing translations in development
    saveMissing: process.env.NODE_ENV === 'development',
    
    // Pluralization
    pluralSeparator: '_',
    contextSeparator: '_'
  });

export default i18n;